import {
    ACTION_SET_CONNECTED,
    ACTION_SET_USER,
    ACTION_UNSET_USER,
    ACTION_SET_USERS,
    ACTION_CREATE_USER,
    ACTION_UPDATE_USER,
} from "../actions/user";

const initialState = {
    account: "",
    balance: 0,
    user: {},
    items: [],
}

export default function user(state = initialState, { type, payload }) {

    switch (type) {
        case ACTION_SET_CONNECTED:
            return { ...state, account: payload };
        case ACTION_SET_USER:
            return { ...state, user: payload };
        case ACTION_UNSET_USER:
            return { ...state, user: {} };
        case ACTION_SET_USERS:
            return { ...state, items: payload };
        case ACTION_CREATE_USER:
            return { ...state, user: payload };
        case ACTION_UPDATE_USER:
            return { ...state, user: {...state.user, ...payload} };
        default:
            return state
    }
}